var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLiveicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_12_10",
    "data-name": "Component 12 \\u2013 10",
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 37.049,
    viewBox: "0 0 56 37.049",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_130",
    "data-name": "Group 130"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_357",
    "data-name": "Path 357",
    d: "M584.2,266.371a2.837,2.837,0,0,0,2.687-1.671,11.7,11.7,0,0,0,0-8.816,3,3,0,0,0-5.374,0,11.716,11.716,0,0,0,0,8.816A2.837,2.837,0,0,0,584.2,266.371Z",
    transform: "translate(-571.524 -241.807)",
    fill: "#e53d3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_358",
    "data-name": "Path 358",
    d: "M571.9,245.453v30.685a3.13,3.13,0,0,0,3.13,3.13h22.221V242.323H575.034A3.131,3.131,0,0,0,571.9,245.453Zm7.015,8.482a7.521,7.521,0,0,1,11.321,0,13.47,13.47,0,0,1,0,13.721,7.519,7.519,0,0,1-11.321,0,13.475,13.475,0,0,1,0-13.721Z",
    transform: "translate(-571.904 -242.323)",
    fill: "#e53d3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_359",
    "data-name": "Path 359",
    d: "M623.5,242.423H601.278v36.945H623.5a3.13,3.13,0,0,0,3.13-3.13V245.553A3.131,3.131,0,0,0,623.5,242.423Zm-4.968,26.064a7.469,7.469,0,0,1-4.969,1.631,10.778,10.778,0,0,1-6.13-2.14l1.668-3.235a8.313,8.313,0,0,0,4.617,1.826,3.27,3.27,0,0,0,2.022-.6,2.04,2.04,0,0,0,.8-1.735,2.113,2.113,0,0,0-.913-1.8,4.225,4.225,0,0,0-2.529-.665,8.737,8.737,0,0,0-2.427.495v-3l3.5-4.12h-5.713v-3.47h11.166v2.818l-3.731,4.251a5.316,5.316,0,0,1,3.391,1.84,5.236,5.236,0,0,1,1.2,3.4A5.555,5.555,0,0,1,618.531,268.487Z",
    transform: "translate(-570.629 -242.319)",
    fill: "#e53d3d"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveicon);
export default __webpack_public_path__ + "lbHeaderFiles/static/media/live.icon.f32eebf9ee3733454b3354b0fc6767c1.svg";
export { ForwardRef as ReactComponent };